import { apiCall } from '../../context/api';

export const fetchToken = async (email, password, base_url, setToken, setError, rememberMe = false) => {
  try {
    const data = await apiCall(base_url, null, 'POST', '/core/users/login', {
      email,
      password
    });

    setToken(data.token);

    if (rememberMe) {
      localStorage.setItem('slipstream_token', data.token);
    } else {
      localStorage.removeItem('slipstream_token');
    }
  } catch (error) {
    console.error(error);
    setError(error.message || 'Could not connect to the server. Please check your internet connection and try again.');
  }
};
